<template>
    <div class=" uk-margin-remove-top" style="background-image: url('/WholisticLife.jpg'); background-size: cover">
        <div class="uk-padding-large" style="background-color: rgba(0, 0, 0, 0.7); ">
            <div class="uk-container" >
                <h1 class="uk-text-left">
                    <span class="half-a-border-on-top">Wholistic Life</span>
                </h1>
                <br>
                <p class="uk-light uk-text-left">
                    At NCU the criteria for creating a graduand is not only education-based.
                  NCU is a lifestyle that propels our student to be honorable leaders all over the working world.
                    <br>
                    At NCU we focus on the the four following areas:
                </p>
                <div class="uk-child-width-1-4@m" uk-grid>
                    <div>
                        <div>
                            <div class="uk-card uk-card-default uk-card-small uk-card-body uk-text-left" style="background: transparent">
                                <h3 class="uk-card-title">Social</h3>
                                <p class="uk-light">Clubs, International Student Services, Student Development, Socials, Gospel Events</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div class="uk-card uk-card-default uk-card-small uk-card-body uk-text-left" style="background: transparent">
                                <h3 class="uk-card-title">Mental</h3>
                                <p class="uk-light">Counselling, Morris Entrepreneurship Centre, Lecture Series</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div class="uk-card uk-card-default uk-card-small uk-card-body uk-text-left" style="background: transparent">
                                <h3 class="uk-card-title">Physical</h3>
                                <p class="uk-light">Sports Day, Inter-collegiate Sports, Marathons</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div class="uk-card uk-card-default uk-card-small uk-card-body uk-text-left" style="background: transparent">
                                <h3 class="uk-card-title">Spiritual</h3>
                                <p class="uk-light">Prayer Gardens, Chapel Sessions, Ellen G White Resource Centre</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "wholisticLife"
    }
</script>

<style scoped>
    .half-a-border-on-top {
        //border-top: 2px solid white;
        position: relative;
        color:  gold;
        font-family: soleil, sans-serif !important;
        font-style: normal;
        font-weight: 600;
    }
    .half-a-border-on-top:after {
        padding-top: 10px;
        content: "";
        width:50%;
        height: 2px;/* slight higher to work around rounding errors(?) on some zoom levels in some browsers. */
        //background-color: rgba(0, 0, 0, 0.8);
        position: absolute;
        right:0;
        top:-2px;
    }
    h3{
        color:  gold !important;
    }
    @media screen and (max-width:600px){


        h3{
            font-size: 1.1em !important;
        }
        h1{
            font-size: 1.2em !important;
        }
        p{
            font-size: 0.7em !important;
        }
        a{
            font-size: 0.9em !important;
        }


    }
</style>
